export default __webpack_public_path__ + "static/media/gaEmblem.4bc0f77c.png";